export default __webpack_public_path__ + "static/media/login-banner.156d029a.png";